import Key from "@mui/icons-material/Key";
import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import React from "react";
import { Permission, PutUserRequest } from "../../../models/auth";
import PermissionSelector from "./PermissionSelector";

interface EditUserFormProps {
  readonly form: PutUserRequest;
  readonly setForm: (form: PutUserRequest) => void;
  readonly handleCreateSubmit: () => void;
}

export default function CreateUserForm({ form, setForm, handleCreateSubmit }: EditUserFormProps) {
  const [passwordValidation, setPasswordValidation] = React.useState<string>("");
  const isCloudAuth = window.CONFIG?.auth?.kind !== "SIMPLE";

  const handlePermissionChange = (permissions: Permission[]) => {
    setForm({
      ...form,
      attributes: {
        ...form.attributes,
        permissions: permissions,
      },
    });
  };
  return (
    <form
      onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        handleCreateSubmit();
      }}
    >
      <Stack spacing={2}>
        <FormControl>
          <FormLabel>Email</FormLabel>
          <Input
            required
            value={form.credentials.user}
            onChange={(e) => {
              setForm({
                ...form,
                credentials: {
                  user: e.target.value,
                  password: form.credentials.password,
                },
              });
            }}
          />
        </FormControl>

        <Stack direction="row" spacing={2} justifyContent="space-between">
          <FormControl>
            <FormLabel>Given name</FormLabel>
            <Input
              required
              value={form.attributes.given_name}
              onChange={(e) => {
                setForm({
                  ...form,
                  attributes: {
                    ...form.attributes,
                    given_name: e.target.value,
                  },
                });
              }}
            />
          </FormControl>
          <FormControl>
            <FormLabel>Last name</FormLabel>
            <Input
              required
              value={form.attributes.name}
              onChange={(e) => {
                setForm({
                  ...form,
                  attributes: {
                    ...form.attributes,
                    name: e.target.value,
                  },
                });
              }}
            />
          </FormControl>
        </Stack>
        <FormControl>
          <FormLabel>Organization</FormLabel>
          <Input
            value={form.attributes.organization ?? ""}
            onChange={(e) => {
              setForm({
                ...form,
                attributes: {
                  ...form.attributes,
                  organization: e.target.value,
                },
              });
            }}
          />
        </FormControl>

        <PermissionSelector
          selectedPermissions={form.attributes.permissions || []}
          onChange={handlePermissionChange}
          isCloudAuth={isCloudAuth}
        />
        <Divider />
        <FormControl>
          <FormLabel>Password</FormLabel>
          <Input
            type="password"
            startDecorator={<Key />}
            required
            value={form.credentials.password}
            onChange={(e) => {
              setForm({
                ...form,
                credentials: { user: form.credentials.user, password: e.target.value },
              });
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel>Password (validation)</FormLabel>
          <Input
            type="password"
            startDecorator={<Key />}
            required
            onChange={(e) => setPasswordValidation(e.target.value)}
          />
        </FormControl>
        <Typography level="body-xs" color="danger">
          {form.credentials.password.length < 8 ? "Password must be at least 8 characters" : ""}
        </Typography>
        <Typography level="body-xs" color="danger">
          {form.credentials.password !== passwordValidation ? "Passwords do not match" : ""}
        </Typography>
        <Button type="submit">Submit</Button>
      </Stack>
    </form>
  );
}
